(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["tabs"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__themeTabsInitialized) return;
    window.__themeTabsInitialized = true;

    function setActive(root, index) {
      var tabs = root.querySelectorAll('[data-tabs-tab]');
      var panels = root.querySelectorAll('[data-tabs-panel]');
      if (!tabs.length || tabs.length !== panels.length) return;

      var i = Math.max(0, Math.min(index, tabs.length - 1));

      for (var t = 0; t < tabs.length; t++) {
        var isActive = t === i;
        tabs[t].setAttribute('aria-selected', isActive ? 'true' : 'false');
        tabs[t].setAttribute('tabindex', isActive ? '0' : '-1');
        tabs[t].classList.toggle('tabs__tab--active', isActive);
        tabs[t].classList.toggle('button', isActive);
        tabs[t].classList.toggle('button-secondary', !isActive);

        if (isActive) {
          panels[t].removeAttribute('hidden');
        } else {
          panels[t].setAttribute('hidden', '');
        }
      }
    }

    function defaultIndex(root) {
      var tabs = root.querySelectorAll('[data-tabs-tab]');
      var found = -1;
      tabs.forEach(function (tab, i) {
        if (found === -1 && tab.hasAttribute('data-default-tab')) found = i;
      });
      return found >= 0 ? found : 0;
    }

    function initRoot(root) {
      if (root.getAttribute('data-tabs-initialized') === 'true') return;
      root.setAttribute('data-tabs-initialized', 'true');
      setActive(root, defaultIndex(root));
    }

    function initAll() {
      document.querySelectorAll('[data-tabs]').forEach(initRoot);
    }

    document.addEventListener('click', function (event) {
      var tab = event.target.closest('[data-tabs-tab]');
      if (!tab) return;
      var root = tab.closest('[data-tabs]');
      if (!root) return;
      var tabs = root.querySelectorAll('[data-tabs-tab]');
      var index = Array.prototype.indexOf.call(tabs, tab);
      if (index === -1) return;
      setActive(root, index);
    });

    document.addEventListener('keydown', function (event) {
      var tab = event.target.closest('[data-tabs-tab]');
      if (!tab || !tab.matches(':focus')) return;
      if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft' && event.key !== 'Home' && event.key !== 'End')
        return;

      var root = tab.closest('[data-tabs]');
      if (!root) return;
      var tabs = root.querySelectorAll('[data-tabs-tab]');
      var ix = Array.prototype.indexOf.call(tabs, tab);
      if (ix === -1) return;

      event.preventDefault();
      var next = ix;
      if (event.key === 'ArrowRight') next = (ix + 1) % tabs.length;
      if (event.key === 'ArrowLeft') next = (ix - 1 + tabs.length) % tabs.length;
      if (event.key === 'Home') next = 0;
      if (event.key === 'End') next = tabs.length - 1;

      setActive(root, next);
      tabs[next].focus();
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', initAll);
  })();
  } catch(e) { console.error(e); }
})();

})();
